import { useGtag } from "vue-gtag-next";
import { router } from "@/router";
export const gtag = useGtag();
/*
gtag.config({
  property: {
    id: "G-9S14N2SNRS",
    includes: [{ id: "AW-967082918" }],
    accept_incoming: true,
  },
});*/
